import Button from '@quicktools/shared-components/components/core/Button';

import useStyles from './styles';

export default function MoreInfo({ props }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <h2 className={classes.title}>{props.title}</h2>
      <p className={classes.description}>{props.description}</p>
      <a href="https://support.picsart.com/hc/en-us/requests/new" target="_blank" rel="noreferrer">
        <Button className={classes.btn}>{props.btn}</Button>
      </a>
    </div>
  );
}
